import request from '@/router/axios'
import env from '@/config/env'

/**
 * 查询支出/收款公司（供应商及其下属供应商）
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET',
  })
}

/**
* 获取线路名称
* @param id
*/
export const queryAllLowLine = (id) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/getLineByMerchantIds?merchantId=${id}`,
    method: 'GET',
  })
}

/**
 * 删除票款结算规则
 * @param settleFerryDeleteReqList
 */
 export const removeFerryTicketRule = (settleFerryDeleteReqList) => {
  return request({
      url: env.ferryUrl + '/settle-ferry-rule/delete-ferry',
      method: 'POST',
      data: settleFerryDeleteReqList
  })
}

/**
 * 获取摆渡结算规则分页
 * @param data
 */
export const selectCustomSumTotal = (settleFerryRulePage) => {
  return request({
    url: env.ferryUrl + '/settle-ferry-rule/page',
    method: 'POST',
    data: data
  })
}

/**
 * 获取摆渡结算规则分页
 * @param settleFerryRulePageDto
 */
 export const settleFerryRulePage = (settleFerryRulePageDto) => {
  return request({
    url: env.ferryUrl + '/settle-ferry-rule/page',
    method: 'POST',
    data: settleFerryRulePageDto
  })
}

/**
 * 获取接送服务区域
 * @param 
 */
 export const getServiceAreaItem = (areaManageId) => {
  return request({
    url: env.ferryUrl + `/priceModuleManage/serviceAreaList/${areaManageId}`,
    method: 'POST',
  })
}

/**
 * 新增、编辑摆渡费结算规则
 * @param data
 */
 export const saveFerrySettle = (data) => {
  return request({
    url: env.ferryUrl + '/settle-ferry-rule/save-and-edit',
    method: 'POST',
    data: data
  })
}

/**
 * 获取摆渡费结算规则详情
 * @param data
 */
 export const settleFerryDetails = (id) => {
  return request({
    url: env.ferryUrl + `/settle-ferry-rule/detail/${id}`,
    method: 'GET',
  })
}


/**
 * 删除票款结算单独配置规则
 * @param data
 */
 export const removeSettleFerryRuleConfig = (data) => {
  return request({
      url: env.ferryUrl + '/settle-ferry-rule/delete-rule',
      method: 'POST',
      data: data
  })
}

/**
 * 摆渡结算规则-统一结算规则历史记录
 * @param data
 */
 export const historyDefault = (id) => {
  return request({
    url: env.ferryUrl + `/settle-ferry-rule/history-default/${id}`,
    method: 'GET',
  })
}
/**
 * 摆渡结算规则-特殊区域结算规则历史记录
 * @param data
 */
 export const historyArea = (id) => {
  return request({
    url: env.ferryUrl + `/settle-ferry-rule/history-area/${id}`,
    method: 'GET',
  })
}
/**
 * 摆渡结算规则-特殊区域结算规则历史记录
 * @param data
 */
 export const historyLine = (id) => {
  return request({
    url: env.ferryUrl + `/settle-ferry-rule/history-line/${id}`,
    method: 'GET',
  })
}